import {connect} from 'react-redux'
import {getPathName} from 'data/redux/selectors/routerSelector';
import LinkRadio from 'gui/components/linkRadio';


const mapStateToProps = ({router, navigation}, ownProps) => {
  if (typeof ownProps.preProcessesTo === 'function') {
    ownProps.to = ownProps.preProcessesTo(router, navigation.history) || ownProps.to;
  }
  return {
    currentPathName: getPathName({router}),
    ...ownProps,
  };
};

export const mapDispatchToProps = (dispatch, ownProps?) => {
  return {};
};

const LinkRadioContainer = connect(mapStateToProps, mapDispatchToProps)(LinkRadio);

export default LinkRadioContainer;
